<!-- Container for sidebar(s) + page content -->
<ng-alt-sidebar-container class="mapfre-sidebar">

     <!-- A sidebar -->
    <ng-alt-sidebar [(opened)]="opened" [mode]="'push'" [dock]="true" [dockedSize]="'100px'"  class="{{ loading ? 'disable' : ''}}">
        <div class="content">
            <span (click)="_toggleSidebar()" style="position: absolute;top: 10px;right: 15px;">X</span>
            <ng-content select="[sidebar-content]"></ng-content>
        </div>
    </ng-alt-sidebar>

    <!-- Page content  -->
    <div ng-alt-sidebar-content>
        <ng-content select="[web-content]"></ng-content>
    </div>

</ng-alt-sidebar-container>
